import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'contacts_search_page' */ './SearchPage'),
);
